import React, { PureComponent } from 'react';
import { ReactComponent as IconChevronRight } from '../../../assets/svg/chevron-right.svg';
import { CATEGORIES, TIMETABLES_ACTION, logEvent } from '../../../services/AnalyticsService';

const AT_WEBSITE_URL = (process.env.REACT_APP_AT_WEBSITE_URL || 'https://at.govt.nz/').replace(/\/?$/, '/');
const TRAIN_TIMETABLES_URL = `${AT_WEBSITE_URL}bus-train-ferry/timetables`;

export default class TrainTimetableInfo extends PureComponent {
  _logClick = () => {
    logEvent(CATEGORIES.TIMETABLES, TIMETABLES_ACTION.TRAIN_TIMETABLE, 'Train timetable link selected');
  };

  render() {
    return (
      <div className="tt-train-timetable-info">
        <div className="tt-train-timetable-info__heading">Train timetables</div>
        <p className="tt-train-timetable-info__description">
          Find timetables for the East West, Onehunga West and South City lines.
        </p>
        <p className="tt-train-timetable-info__link">
          <a
            className="at-btn at-btn--borderless at-btn--dark"
            href={TRAIN_TIMETABLES_URL}
            onClick={this._logClick}
          >
            View train timetables
            <IconChevronRight className="tt-train-timetable-info__link-icon" role="img" aria-hidden="true" focusable="false" />
          </a>
        </p>
      </div>
    );
  }
}
